import { ExclusiveRewardDeliveryType, ExclusiveRewardOptionGroup, ExclusiveRewardOrderItem, ExclusiveRewardsAddress, NonFoodCustomerInfo } from '@app/core/models/loyalty.model';
import { AttributedText } from '@app/core/redux/stores';


export class NonFoodOrder {    
    id: number;
    name: string;
    descriptionHtml?: string;
    descriptionAttributedText?: AttributedText[];
    points: number;
    imageUrl: string;
    customerInfo?: NonFoodCustomerInfo;
    address?: ExclusiveRewardsAddress;
    optionGroups: ExclusiveRewardOptionGroup[];
    summaryDescription?: string;
    deliveryType: ExclusiveRewardDeliveryType;
}
